import React from 'react';
import { dayLocationSummary } from './dayLocationSummary';

export default function DayLocationSummary({ entries, sceneByUid, locations, draftLocations }) {
  const groups = dayLocationSummary(entries, sceneByUid, locations, draftLocations);
  let locationNumber = 0;
  return <div className="pp-day-location-summary" role="group" aria-label="Day location and scene summary">
    {!groups.length && <p className="pp-small pp-muted">Location not assigned</p>}
    {groups.map(group => <div key={group.key} className="pp-day-location-group">
      <p className="pp-day-location-name"><strong>{group.name ? `Location ${++locationNumber} — ${group.name}` : 'Location not assigned'}</strong></p>
      <ul className="pp-day-location-scenes">{group.scenes.map((scene, i) => <li key={`${scene.occurrenceId}:${i}`}>Scene {scene.number} — {scene.heading}</li>)}</ul>
    </div>)}
  </div>;
}